import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import {
  Address,
  GetPolicyholderDetailsClientResponse,
  MatchedEntity,
  Result,
} from '../@types/PolicyHolderDetails'

type Store = {
  phoneSelected: string
  setPhoneSelected: (value: string) => void
  professionSelected: Result | null
  setProfessionSelected: (value: Result) => void
  policyholderDetails: GetPolicyholderDetailsClientResponse | null
  setPolicyholderDetails: (value: GetPolicyholderDetailsClientResponse) => void
  policyholderDetailsSelected: MatchedEntity | null
  setPolicyholderDetailsSelected: (value: MatchedEntity) => void
  policyholderAddressSelected: Address | null
  setPolicyholderAddressSelected: (value: Address) => void
  resetPolicyholderDetails: () => void
}

export const usePolicyholderDetailsStore = create<Store>()(
  devtools(
    (set) => ({
      phoneSelected: '',
      setPhoneSelected: (phoneSelected) => set({ phoneSelected }),
      professionSelected: null,
      setProfessionSelected: (professionSelected) =>
        set({ professionSelected }),
      policyholderDetails: null,
      setPolicyholderDetails: (policyholderDetails) =>
        set({ policyholderDetails }),
      policyholderDetailsSelected: null,
      setPolicyholderDetailsSelected: (policyholderDetailsSelected) =>
        set({ policyholderDetailsSelected }),
      policyholderAddressSelected: null,
      setPolicyholderAddressSelected: (policyholderAddressSelected) =>
        set({ policyholderAddressSelected }),
      resetPolicyholderDetails: () =>
        set({
          policyholderDetailsSelected: null,
          policyholderDetails: null,
          phoneSelected: '',
          professionSelected: null,
          policyholderAddressSelected: null,
        }),
    }),
    { name: 'PolicyholderDetailsStore' },
  ),
)
